module.exports = __webpack_public_path__ + "media/assets/images/flags/ni-2bf1cff193057eb5d331f88073152033.svg";